module.exports = __webpack_public_path__ + "static/media/pool-skimmer-image-1.8c623504.jpg";